import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", function () {
  let colorBlack = "#100b0b";
  let colorWhite = "#fefdf1";
  let colorRed = "#3c1b16";
  const buttonStart = document.querySelector(".button-start");
  const startContent = document.querySelector(".l-startcontent");

  const ids = {};
  [
    "scroll-indication",
    "natalias1",
    "text1s1",
    "bgs2",
    "blacksads2",
    "natalias2",
    "text1s2",
    "cards",
    "text2s2",
    "bgs3",
    "bgs3after",
    "blacksads3",
    "text1s3",
    "threat",
    "text2s3",
    "flowerwhite",
    "flowerpink",
    "flowerred",
    "doorbell",
    "finger",
    "text1s4",
    "door",
    "text2s4",
    "bgs4",
    "bgs5",
    "bgs6",
    "forest",
    "text1s6",
    "dancenatalia",
    "dancebg",
    "petal1",
    "petal2",
    "bgs7",
    "text1s7",
    "party",
    "breakup",
    "breakupafter",
    "text2s7",
    "leaving",
    "bgs8",
    "text1s8",
    "bgs9",
    "text1s9",
    "text2s9",
    "fist",
    "text1s10",
    "blacksads10",
    "blam1",
    "blam2",
    "debris1",
    "debris2",
    "text2s10",
    "smirnov",
    "rat",
    "bear",
    "lizard",
    "pig",
    "bgtitle",
    "title",
    "story-img-wrapper",
    "flowers",
  ].forEach((id) => {
    ids[id] = document.getElementById(id);
  });

  document.querySelector("html").style.overflow = "hidden";

  // bouton de lancement
  var start = function () {
    console.log("test");
    startContent.classList.add("fades");
    setTimeout(() => {
      startContent.style.display = "none";
      document.querySelector("html").style.overflow = "auto";
    }, 1000);

    //Mon système d'animation actuel ne fonctionne pas comme il devrait: les
    //images arrivent et partent de façon linéaire et l'effet au scroll est
    //beaucoup trop sensible. J'ai décidé de rendre cette version qui marche
    //et est tout de même compréhensible et de revenir sur le site plus tard
    //quand j'en aurai l'occasion, dans le but de corriger tout ça.

    // animations
    let totalDuration = 3000;
    let durationNormal = totalDuration * 0.1;
    let durationQuick = totalDuration * 0.05;
    let durationSlow = totalDuration * 0.2;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#story-img-wrapper",
        start: "top top",
        end: "+=3000",
        scrub: true,
        pin: "#story-container",
        markers: false,
      },
    });

    tl.to("#scroll-indication", {
      opacity: 0,
      duration: 1,
    });

    //-------------------------------- SCENE 1 ---------------------------------
    tl.to("#natalias1", {
      transform: "scale(1, 1) translate(-300px, -100px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s1", {
      transform: "scale(0.8, 0.8) translate(300px, -100px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#natalias1", {
      transform: "scale(1.5, 1.5) translate(-500px, -200px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text1s1", {
      transform: "scale(1.3, 1.3) translate(500px, -200px)",
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 2 ---------------------------------
    tl.to("#story-img-wrapper", {
      backgroundColor: colorWhite,
      duration: durationNormal,
    });

    tl.to("#bgs2", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blacksads2", {
      transform: "scale(0.85, 0.85) translate(-260px, -160px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#natalias2", {
      transform: "scale(0.75, 0.75) translate(80px, -20px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s2", {
      transform: "scale(0.75, 0.75) translate(-500px, 390px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#cards", {
      transform: "scale(0.7, 0.7) translate(600px, -400px)",
      opacity: 1,
      duration: durationNormal,
      rotate: -30,
    });

    tl.to("#text2s2", {
      transform: "scale(1, 1) translate(470px, -45px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blacksads2", {
      transform: "scale(1.3, 1.3) translate(-500px, -220px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#natalias2", {
      transform: "scale(1.3, 1.3) translate(500px, -100px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text1s2", {
      transform: "scale(1.8, 1.8) translate(-700px, 400px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#cards", {
      transform: "scale(1.3, 1.3) translate(800px, -600px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s2", {
      transform: "scale(1.4, 1.4) translate(800px, -100px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs2", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 3 ---------------------------------
    tl.to("#bgs3", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#bgs3after", {
      duration: durationNormal,
    });

    tl.to("#blacksads3", {
      transform: "scale(0.75, 0.75) translate(-560px, -200px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s3", {
      transform: "scale(0.8, 0.8) translate(-150px, 210px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#threat", {
      transform: "scale(0.7, 0.7) translate(50px, 100px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text2s3", {
      transform: "scale(1, 1) translate(420px, -290px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#bgs3after", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blacksads3", {
      transform: "scale(1.2, 1.2) translate(-700px, -300px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#threat", {
      transform: "scale(1.2, 1.2) translate(150px, 200px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text1s3", {
      transform: "scale(1.2, 1.2) translate(-300px, 350px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s3", {
      transform: "scale(1.2, 1.2) translate(600px, -400px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs3", {
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs3after", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 4 ---------------------------------
    tl.to("#flowers", {
      opacity: 1,
      duration: durationQuick,
    });

    tl.to("#doorbell", {
      transform: "scale(1.2, 1.2) translate(-350px, -225px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#finger", {
      transform: "scale(1.2, 1.2) translate(-445px, -200px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s4", {
      transform: "scale(1, 1) translate(-430px, -50px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#door", {
      transform: "scale(0.6, 0.6) translate(-500px, 500px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#bgs4", {
      transform: "translate(-170px, 25px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text2s4", {
      transform: "scale(1, 1) translate(450px, 400px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#doorbell", {
      transform: "scale(1.6, 1.6) translate(-600px, -350px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#finger", {
      transform: "scale(1.3, 1.3) translate(-800px, -300px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text1s4", {
      transform: "scale(1.3, 1.3) translate(-800px, -100px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#door", {
      transform: "scale(1, 1) translate(-800px, 800px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s4", {
      transform: "scale(1.3, 1.3) translate(800px, 800px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs4", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 5 ---------------------------------
    tl.to("#bgs5", {
      transform: "scale(0.7, 0.7)",
      opacity: 1,
      duration: durationSlow,
    });

    tl.to("#bgs5", {
      transform: "scale(0.9, 0.9)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#flowers", {
      opacity: 0,
      duration: durationQuick,
    });

    //-------------------------------- SCENE 6 ---------------------------------

    tl.to("#bgs6", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#forest", {
      transform: "scale(1, 1) translate(-200px, -180px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s6", {
      transform: "scale(0.85, 0.85) translate(-400px, 100px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#dancebg", {
      transform: "scale(0.55, 0.55) translate(650px, 350px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#dancenatalia", {
      transform: "scale(0.57, 0.57) translate(600px, 350px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#dancenatalia", {
      scaleX: -0.57,
      duration: durationNormal,
    });

    tl.to("#forest", {
      transform: "scale(1.3, 1.3) translate(-400px, -250px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text1s6", {
      transform: "scale(1, 1) translate(-600px, 200px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#dancebg", {
      transform: "scale(0.7, 0.7) translate(800px, 500px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#dancenatalia", {
      transform: "scale(0.7, 0.7) translate(800px, 500px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs6", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 7 ---------------------------------
    tl.to("#story-img-wrapper", {
      backgroundColor: colorRed,
      duration: durationNormal,
    });

    tl.to("#bgs7", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s7", {
      transform: "scale(0.9, 0.9) translate(-500px, -350px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#party", {
      transform: "scale(0.8, 0.8) translate(-570px, 230px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#breakup", {
      transform: "scale(0.8, 0.8) translate(50px, 0px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#breakupafter", {
      transform: "scale(0.8, 0.8) translate(50px, 0px)",
      duration: durationNormal,
    });

    tl.to("#text2s7", {
      transform: "scale(0.9, 0.9) translate(270px, 520px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#breakupafter", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#leaving", {
      transform: "scale(0.8, 0.8) translate(550px, 0px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#petal1", {
      transform: "scale(1, 1) translate(520px, 500px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#petal2", {
      transform: "scale(1, 1) translate(470px, 390px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s7", {
      transform: "scale(1.2, 1.2) translate(-700px, -550px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#party", {
      transform: "scale(1.1, 1.1) translate(-770px, 430px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#breakup", {
      transform: "scale(1.1, 1.1) translate(200px, 0px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#breakupafter", {
      transform: "scale(1.1, 1.1) translate(200px, 0px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#leaving", {
      transform: "scale(1.1, 1.1) translate(850px, 0px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#petal1", {
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#petal2", {
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s7", {
      transform: "scale(1.2, 1.2) translate(470px, 820px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs7", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 8 ---------------------------------
    tl.to("#story-img-wrapper", {
      backgroundColor: colorBlack,
      duration: durationNormal,
    });

    tl.to("#bgs8", {
      transform: "scale(0.8, 0.8)",
      opacity: 1,
      duration: durationSlow,
    });

    tl.to("#text1s8", {
      transform: "scale(1, 1) translate(0px, 400px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s8", {
      transform: "scale(1.3, 1.3) translate(0px, 600px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs8", {
      transform: "scale(1.1, 1.1)",
      opacity: 0,
      duration: durationNormal,
    });
    //-------------------------------- SCENE 9 ---------------------------------
    tl.to("#bgs9", {
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s9", {
      transform: "scale(0.9, 0.9) translate(-140px, -320px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text2s9", {
      transform: "scale(0.9, 0.9) translate(200px, 320px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#fist", {
      transform: "scale(0.6, 0.6) translate(550px, 120px)",
      opacity: 1,
      duration: durationNormal,
      rotate: 10,
    });

    tl.to("#text1s9", {
      transform: "scale(1.2, 1.2) translate(-240px, -520px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s9", {
      transform: "scale(1.2, 1.2) translate(400px, 520px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#fist", {
      transform: "scale(0.9, 0.9) translate(800px, 220px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bgs9", {
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 10 --------------------------------
    tl.to("#story-img-wrapper", {
      backgroundColor: colorRed,
      duration: durationNormal,
    });

    tl.to("#text1s10", {
      transform: "scale(0.75, 0.75) translate(-400px, -420px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blacksads10", {
      transform: "translate(500px, -100px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blam1", {
      transform: "scale(0.85, 0.85) translate(-400px, 150px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#blam2", {
      transform: "scale(0.66, 0.66) translate(-350px, 430px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text2s10", {
      transform: "scale(0.75, 0.75) translate(500px, 520px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#text1s10", {
      transform: "scale(1, 1) translate(-600px, -720px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#blacksads10", {
      transform: "translate(700px, -200px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#blam1", {
      transform: "scale(1, 1) translate(-600px, 250px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#blam2", {
      transform: "scale(0.9, 0.9) translate(-550px, 630px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#text2s10", {
      transform: "scale(1, 1) translate(500px, 520px)",
      opacity: 0,
      duration: durationNormal,
    });

    //-------------------------------- SCENE 11 --------------------------------

    tl.to("#smirnov", {
      transform: "scale(0.8, 0.8) translate(-650px, -50px)",
      opacity: 1,
      duration: durationNormal,
      rotate: -5,
    });

    tl.to("#bear", {
      transform: "scale(1, 1) translate(-50px, -70px)",
      opacity: 1,
      duration: durationNormal,
    });

    tl.to("#rat", {
      transform: "scale(0.65, 0.65) translate(-400px, 0px)",
      opacity: 1,
      duration: durationNormal,
      rotate: -2,
    });

    tl.to("#lizard", {
      transform: "scale(0.63, 0.63) translate(460px, 80px)",
      opacity: 1,
      duration: durationNormal,
      rotate: 5,
    });

    tl.to("#pig", {
      transform: "scale(0.85, 0.85) translate(530px, -50px)",
      opacity: 1,
      duration: durationNormal,
      rotate: 5,
    });

    tl.to("#smirnov", {
      transform: "scale(1.1, 1.1) translate(-880px, -100px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#bear", {
      transform: "scale(1.5, 1.5) translate(-20px, -80px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#rat", {
      transform: "scale(1, 1) translate(-800px, 80px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#lizard", {
      transform: "scale(1, 1) translate(800px, 100px)",
      opacity: 0,
      duration: durationNormal,
    });

    tl.to("#pig", {
      transform: "scale(1.1, 1.1) translate(1100px, -100px)",
      opacity: 1,
      duration: durationNormal,
    });

    //---------------------------- SCENE 12 (TITRE) ----------------------------
    tl.to("#story-img-wrapper", {
      backgroundColor: colorBlack,
      duration: durationNormal,
    });

    tl.to("#bgtitle", {
      opacity: 1,
      duration: durationSlow,
    });

    tl.to("#title", {
      opacity: 1,
      duration: durationSlow,
    });
  };

  buttonStart.addEventListener("click", start);
});
